import React from 'react'
import Loadable from "react-loadable";
import LoadingCircle from "../Loading/LoadingCircle";

const UserMenuLazy = Loadable({
    loader: () => import('./UserMenu'),
    loading: LoadingCircle
})

const UserMenu = (props) => (
    <UserMenuLazy {...props} />
)

export default UserMenu
